import React, { useEffect, useState } from 'react';
import './_User.scss'
import { useTranslation } from 'react-i18next';
import AssignResident from './Assign/AssignResident';
import ApiGo from '../../actions/ApiGo';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { ADD_USERS_ARRAY } from '../../stores/reducer_usersArray';
import { ADD_RESPONSE, ADD_RESPONSE_JSON } from '../../stores/reducer_add';

const User = (props) =>{

    // i18n翻譯
    const { t, i18n } = useTranslation();
   
    // 準備map的html格式容器
    const [totalvalue,setTotalvalue] = useState([])

    // 彈出視窗呈現，給受護者分配使用
    const [assignResOpen, setAssignResOpen] = useState(false);
    function toggleAssignRes(){ setAssignResOpen(!assignResOpen) }
    // 當觸發按鈕時將user資料託給setUserSelectedInfo(user_info)，再透過userSelectedInfo將資料傳向子層
    const [userSelectedInfo, setUserSelectedInfo] = useState();
    
    // 配完受護者，重整，透過refresh 來re-render整個component
    const [refresh, setRefresh] = useState(false);
    function toggleRefresh(){ setRefresh(!refresh) }
    
    // ----------- redux ---------------
    // store_users_array 代表從 comm_store.js 取得[key]store_users的[value]ReducerUsersArray
    const store_users_array = useSelector(state => state.store_users)
    const store_residents_array = useSelector(state => state.store_residents)
    // ----------- redux ---------------

    // account role base
    let currentAccount = localStorage.getItem("currentAccount")
    const accountRole = currentAccount!==null? JSON.parse(localStorage.getItem(currentAccount)).role:null
    // account role base

    // [生命週期]每當讀入此component時，先將各別user的部分資料收集
    useEffect(()=>{ 
        let user_arr = [] // 為什麼要用這個格式?
        let _resident = store_residents_array.orign_residents_array || [] // [Redux]提取residents資料
        let _users = store_users_array.orign_users_array || [] // [Redux]提取users資料
        // 建立後續要收集資料的格式模板
        let json_basic_format = {
            "email":``,
            "name":``,
            "role":``,
            "resident_assign":[],
        }
        // 當users資料不是 0 筆
        if(_users.length !== 0){
            _users.forEach(p=>{ // 無法在這部分做資料處理? 觸發deleteUser功能前後來源不同，資料格式不同
                // 過濾users內的資料且權限(role)為doctor才收集
                if(p.role === "doctor"){
                    if(i18n.language==="en"){
                        json_basic_format ={
                            "email":`${p.email}`,
                            "name":`${p.first_name} ${p.last_name}`,
                            "role":`${p.role}`,
                            "resident_assign":[],
                        }
                    }else{
                        json_basic_format ={
                            "email":`${p.email}`,
                            "name":`${p.last_name}${p.first_name}`,
                            "role":`${p.role}`,
                            "resident_assign":[],
                        }
                    }
                    
                    // 如果有被指派受護者
                    if(p.resident_assign !== null){
                        // 需要拆解出單一受護者id
                        p.resident_assign.split(",").forEach(p2=>{
                            _resident.forEach(resident_p=>{
                                // 逐一比對id是否與resident id相符
                                if(Number(p2) === resident_p.id){
                                    // 若相符合，將resident的床號(first_name)、稱呼(last_name)，push到模板中的resident_assign中
                                    json_basic_format.resident_assign.push(resident_p.first_name+" "+resident_p.last_name)
                                }
                            })
                        })
                    }
                    user_arr.push(json_basic_format)
                }
            })
        }
        // TODO FIX
        props.setReturnData(user_arr.length) 
        // 將網頁需要的資料收集，透過map生出標題以外的html
        setTotalvalue(user_arr)
    },[t, i18n, store_users_array, store_residents_array, props]) // 持續監聽list項目，確保放入到setTotalvalue內容為最新資料


    // 當刪除照護者時觸發re-render的useState
    const [activateRedux, setActivateRedux] = useState(false);
    // --------------- redux --------------- 
    const dispatch = useDispatch() // [Redux]影響帳戶內容
    // --------------- redux --------------- 
    
    // 刪除照護者功能
    function deleteUser(email,role){
        var confirm_info = window.confirm(
            t('POP_UP.Delete_caregiver_confirm') + `\n[${role}]${email} ?`
        )
        if (confirm_info===true){
            window.alert(t('POP_UP.Delete_account_success') + `\n[${role}]${email}`)
            // 因為API可以判斷是否有resident並移除resident內的user id所以可以省略判斷的步驟
            ApiGo.deleteUser(email, role)
            .then(()=>{ 
                setActivateRedux(true);
                dispatch(ADD_RESPONSE({status:200, statusText:"success", type:"delete_user"}))
            })
            .catch(err=>{
                dispatch(ADD_RESPONSE({status:err.status, statusText:err.statusText, type:"delete_user"})) 
                return err.response
            })
            .then(res=>{ dispatch(ADD_RESPONSE_JSON(res)) })
        }else{ 
            window.alert(t('POP_UP.Delete_caregiver_cancel') + `\n[${role}]${email}`) 
        }
    }

    useEffect(() => {
        if(activateRedux){
            ApiGo.getUsers().then(res=>{ // getUsers()之後的格式?
                const users_data = res.users // 轉換成需要的格式才能update正確的資訊
                dispatch(ADD_USERS_ARRAY(users_data))
            })
        }setActivateRedux(false)
    }, [activateRedux, dispatch]);
    

    return(
        <>
        {assignResOpen? <AssignResident data={userSelectedInfo} hide={toggleAssignRes} toggleRefresh={toggleRefresh}/>:null}
        <div className="wrap-user fx-d-c h-100">
            {/* 各分項title */}
            <div className="user-row-head">
                <div className='d-flex head'>
                    <div className="flex-grow-2 head-container"><div className="head">{t("GLOBAL.ACCOUNT")}</div></div>
                    <div className="flex-grow-1 head-container"><div className="head">{t("GLOBAL.NAME")}</div></div>
                    <div className="flex-grow-1 head-container"><div className="head">{t("USERS.JOB_TITLE")}</div></div>
                    {accountRole==="superdoctor"?<>
                        <div className="flex-grow-2 head-container"><div className="head">{t("NAV_BAR.RESIDENTS")}</div></div>
                        <div className="flex-grow-2 head-container"><div className="head">{t("RESIDENTS.FUNCTION")}</div></div>
                        </>:<>
                        <div className="flex-grow-4 head-container"><div className="head">{t("NAV_BAR.RESIDENTS")}</div></div>
                    </>}
                </div>
            </div>
            <div className='reset-height'>
            {totalvalue.map((user_info, index)=>{
                return(
                    <div key={user_info.email+index} className="user-row-body">
                        <div className='d-flex'>
                            <div className="flex-grow-2 body-container"><div className="body">{user_info.email}</div></div>
                            <div className="flex-grow-1 body-container"><div className="body">{user_info.name}</div></div>
                            <div className="flex-grow-1 body-container"><div className="body">{user_info.role}</div></div>
                            {accountRole==="superdoctor"?<>
                                <div className="flex-grow-2 body-container">
                                    <div className="body resident-array">
                                        {user_info.resident_assign.map(p=>{
                                            return (<div key={p}>{p}</div>)
                                        })}
                                    </div>
                                </div>
                                <div className="flex-grow-1 body-container">
                                    <div className="body">
                                        <div className="button cursor pt"
                                            onClick={()=>{
                                                toggleAssignRes();
                                                setUserSelectedInfo(user_info)
                                            }}>{t("PAD.ASSIGN")}</div>
                                    </div> 
                                </div>
                                <div className="flex-grow-1 body-container">
                                    <div className="body">
                                        <div className="button cursor pt"
                                            onClick={()=>{
                                                deleteUser(user_info.email,user_info.role)
                                            }}>{t('RESIDENTS.DELETE')}</div>
                                    </div> 
                                </div>
                            </>:<>
                                <div className="flex-grow-4 body-container">
                                    <div className="body resident-array">
                                        {user_info.resident_assign.map(p=>{
                                            return (<div key={p}>{p}</div>)
                                        })}
                                    </div>
                                </div>
                            </>} 
                        </div>
                    </div>
                )}
            )}
            </div>
        </div>
        </>
    )
}

export default User
